import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'activate:reader': () => import('./components/activate'),
        'page:menu:item': () => import('./components/items')
    }
});
